import styled, { css } from 'styled-components';
import { getSpace } from '../../../foundation/theme/space.utils';
import tokens from '../../../foundation/tokens/js/tokens';
import { MAPPINGS_MODE, MAPPINGS_SCALE } from './Radio.constants';
// styled-components.
// -----------------------------------------------------------------------------
export const RadioHidden = styled.input.attrs({ type: 'radio' }) `
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;
export const RadioLabel = styled.label `
  ${({ scale, theme }) => {
    const { fontSize, fontWeight } = MAPPINGS_SCALE[scale];
    return css `
      align-items: center;
      cursor: pointer;
      display: inline-flex;
      font-family: ${theme.typography.fontFamily};
      font-size: ${fontSize};
      font-weight: ${fontWeight};
      gap: ${getSpace('s')};
      line-height: ${tokens.font.lineHeight.text.value};
    `;
}}
`;
export const RadioVisible = styled.div `
  ${({ checked: isChecked, disabled: isDisabled, mode }) => {
    const { background, border, checked, disabled, hover } = MAPPINGS_MODE[mode];
    return css `
      border-radius: 50%;
      cursor: pointer;
      flex-shrink: 0;
      height: ${getSpace('2xl')};
      position: relative;
      transition: 0.3s;
      width: ${getSpace('2xl')};

      /* Mode */
      background-color: ${background};
      border: 2px solid ${border};

      &:hover {
        border-color: ${hover.border};
      }

      &.error {
        border-color: ${tokens.colors.red[700].value};
      }

      ${isDisabled &&
        `
          background-color: ${disabled.background} !important;
          border-color: ${disabled.border} !important;
          color: ${disabled.text} !important;
          pointer-events: none;
        `}

      ${isChecked &&
        `
        background-color: ${checked.background};
        border-color: ${checked.border};
      `}

      &::after {
        background-color: ${border};
        border-radius: 50%;
        content: '';
        height: 50%;
        margin-top: 50%;
        margin-left: 50%;
        opacity: ${isChecked ? 1 : 0};
        position: absolute;
        transform: translate(-50%, -50%);
        transition: 0.3s;
        width: 50%;
      }
    `;
}}
`;
export const RadioWrapper = styled.div `
  align-items: center;
  display: inline-flex;
`;
//# sourceMappingURL=Radio.styled.js.map